jQuery(document).ready(function($){
    $('.cs-hero-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
    });
    $('.cs-announcetment-content').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 9000,        
        autoplay: true,
        autoplaySpeed: 0, 
        cssEase: 'linear',   
        infinite: true,
        arrows: false,
        dots: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        responsive: [
		{
		  breakpoint: 767,
		  settings: {
			slidesToShow: 1
		  }
		}
	  ]
    });
    $('.sft-faq-accordion-content').hide();
    $('.sft-faq-accordion-header').removeClass('sft-faq-active');

    // Open first
    $('.sft-faq-accordion-content').first().show();
    $('.hr-faq .sft-faq-accordion-content').first().hide();
    $('.sft-faq-accordion-header').first().addClass('sft-faq-active');
    $('.hr-faq .sft-faq-accordion-header').first().removeClass('sft-faq-active');

    // Click event
    $('.sft-faq-accordion-header').on('click', function () {

        const $content = $(this).next('.sft-faq-accordion-content');

        // If already open → close it
        if ($content.is(':visible')) {
            $content.slideUp();
            $(this).removeClass('sft-faq-active');
            return;
        }

        // Close others
        $('.sft-faq-accordion-content').slideUp();
        $('.sft-faq-accordion-header').removeClass('sft-faq-active');

        // Open current
        $content.slideDown();
        $(this).addClass('sft-faq-active');

    });
    
    console.log('btnclicked');
    $("#joinnow-btn").click(function(){
        console.log('btnclicked');
        $('.joinnow-pop').show();
        event.preventDefault();
    });
    $(".joinnow-cross").click(function(){
        $('.joinnow-pop').hide();
    });

    /* cstm-buy btn */
    $(".shopify-payment-button").on('click', function (event) {
        event.preventDefault();      
            $( ".shopify-payment-button__more-options").trigger( "click");
    }); 
    $('.cstm_addproductincartqt').click(function (event) {
        event.preventDefault();
        $('.product-form__submit[name="add"]').trigger('click');
    });

    $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
        if (scroll >= 600) {
            $(".cstm_stickybtn").addClass("active");
        } else {
            $(".cstm_stickybtn").removeClass("active");
        }
    });

    /*********** Display selected color varition image **********/
        function filterVariationImages() {
            var value = $('.cstm-productvarcheck .cstm_check_color:checked').val();
            if (!value) {
                return;
            }
            value = value.toLowerCase().trim();
            $('.thumbnail-list__item').each(function () {
                var img = $(this).find('img'); 
                var image_src = img.attr('src');
                if (!image_src) return;
                var image_name = image_src.toLowerCase().split('/').pop();
                var is_default_image = image_name.includes('_all') || !image_name.includes('_');
                var image_color = '';
                if (image_name.includes('_')) {
                    image_color = image_name.split('_')[1].split('-')[0].split('.')[0];
                }
                if (image_color === value || is_default_image) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }
        $(document).on('click', '.cstm-productvarcheck .cstm_check_color', function () {
            filterVariationImages();
        });
        $(window).on('load', function () {
            filterVariationImages();
        });
    /*********** End display selected color varition image **********/
});